module.exports = __webpack_public_path__ + "img/partner-other-1.27445861.png";